var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAremxyPlug(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 22,
    viewBox: "0 0 44 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9358 18.4921H9.76391L11.2649 13.6505H13.3369L12.1622 9.79053H18.4598L22.7996 21.62H16.0125L14.9358 18.4754V18.4921ZM35.9657 0.589844C39.8324 0.589844 43.0138 3.81757 43.0138 7.77736C43.0138 11.7371 39.8487 14.9649 35.9657 14.9649H32.5233V21.6699H26.1115V9.70734H34.5137C35.5578 9.70734 36.4062 8.84218 36.4062 7.77736C36.4062 6.71254 35.5578 5.84738 34.5137 5.84738L12.0643 5.86402L7.023 21.6366H0.382812L7.92032 0.589844H35.9331H35.9657Z",
    fill: "#04177F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAremxyPlug);
export default __webpack_public_path__ + "static/media/AremxyPlug.896137549a4df4fb540320a8f873fd90.svg";
export { ForwardRef as ReactComponent };